import { useParams } from "react-router-dom";
import { SolutionDetailTemplate } from "@/components/detail/SolutionDetailTemplate";
import { getSolutionDetail } from "@/data/solutionDetails";
import NotFound from "@/pages/NotFound";

export default function SolutionDetail() {
  const { slug } = useParams();
  const data = getSolutionDetail(slug);
  if (!data) return <NotFound />;
  return <SolutionDetailTemplate data={data} />;
}
